import { Action, Reducer } from 'redux';
import { AppState } from './appState';
import { setLocaleReducer } from '../../localization/setLocaleAction';
import { loadTranslationsReducer } from '../../localization/loadTranslationsAction';
import { loadConfigReducer } from '../../featureFlags/loadConfigAction';
import { loadFeatureFlagsReducer } from '../../featureFlags/loadFeatureFlagsAction';
import { showLoginAnnouncementReducer } from '../../featureFlags/showLoginAnnouncementAction';
import { updateStateReducer } from './updateStateAction';
import { loginReducer } from '../../auth/login/api/loginAction';
import { loginTalentSmartReducer } from '../../auth/login/api/loginTalentSmartAction';
import { loginBXReducer } from '../../auth/login/api/loginBXAction';
import { securityQuestionReducer } from '../../auth/forgotPassword/api/securityQuestionAction';
import { sendPortalPasswordResetEmailReducer } from '../../auth/forgotPassword/api/sendPortalPasswordResetEmailAction';
import {
  sendRaterApprovalPasswordResetEmailReducer,
} from '../../auth/forgotPassword/api/sendRaterApprovalPasswordResetEmailAction';
import { newPasswordReducer } from '../../auth/accountSetup/api/newPasswordAction';
import { createSecurityChallengeReducer } from '../../auth/accountSetup/api/createSecurityChallengeAction';
import { loadProjectsReducer } from '../../project/loadProjectsAction';
import { securityQuestionKeysReducer } from '../../auth/forgotPassword/api/securityQuestionKeysAction';
import { loadProjMsgsReducer } from '../../project/messages/loadProjMsgsAction';
import { projectLanguagesReducer } from '../../project/messages/projectLanguagesAction';
import { passwordRequirementMessageReducer } from '../../auth/accountSetup/api/passwordRequirementMessageAction';
import { portalLanguagesReducer } from '../../localization/portalLanguagesAction';
import { allLanguagesReducer } from '../../localization/allLanguagesAction';
import { loadProjectSummaryReducer } from '../../project/loadProjectSummaryAction';
import { loadParticipantRequirementsReducer } from '../../project/requirements/loadParticipantRequirementsAction';
import { loadProjectResourcesReducer } from '../../project/resources/loadProjectResourcesAction';
import { addRaterByEmailReducer } from '../../project/survey/raters/addRaterByEmailAction';
import { addRaterByIdReducer } from '../../project/survey/raters/addRaterByIdAction';
import { participantRatersReducer } from '../../project/survey/raters/participantRatersAction';
import { sendInvitationsReducer } from '../../project/survey/raters/sendInvitationsAction';
import { raterLevelsReducer } from '../../project/survey/raters/raterLevelsAction';
import { deleteRaterReducer } from '../../project/survey/raters/deleteRaterAction';
import { loadProjectIdReducer } from '../../project/loadProjectIdAction';
import { logOutReducer } from '../../auth/login/api/logoutAction';
import { updateRaterReducer } from '../../project/survey/raters/updateRaterAction';
import { openMenuReducer } from '../../project/sideMenu/openMenuAction';
import { previousRatersReducer } from '../../project/survey/raters/previousRatersAction';
import { directoryRatersReducer } from '../../project/survey/raters/directorySearch/directoryRatersAction';
import { updateInviteDataReducer } from '../../project/survey/raters/updateInviteDataAction';
import { sendRemindersReducer } from '../../project/survey/raters/remindRaters/sendRemindersAction';
import { setApproverReducer } from '../../project/survey/raters/setApproverAction';
import { updateConfidentialityReducer } from '../../legal/updateConfidentialityAction';
import { sendForApprovalReducer } from '../../project/survey/raters/sendForApprovalAction';
import { ymcaLoginReducer } from '../../auth/sso/YmcaLoginAction';
import { ymcaSsoReducer } from '../../auth/sso/YmcaSsoAction';
import { setGoalAnswerReducer } from '../../project/setGoals/setGoalAnswerAction';
import { sendGoalsReducer } from '../../project/setGoals/sendGoalsAction';
import { goalsAnswersReducer } from '../../project/setGoals/goalsAnswersAction';
import { inviteEmailPreviewReducer } from '../../project/survey/raters/inviteEmailPreviewAction';
import { approverEmailPreviewReducer } from '../../project/survey/raters/approverEmailPreviewAction';
import { setRemindersOnReducer } from '../../project/devPlan/reminders/setRemindersOnAction';
import { getRemindersOnReducer } from '../../project/devPlan/reminders/getRemindersOnAction';
import { getDevPlanItemsReducer } from '../../project/devPlan/api/getDevPlanItemsAction';
import { getDevPlanActionsReducer } from '../../project/devPlan/devPlanAction/api/getDevPlanActionsAction';
import {
  getDevPlanFieldsAndAnswersReducer,
} from '../../project/devPlan/devPlanAction/api/getDevPlanFieldsAndAnswersAction';
import {
  updateDevPlanFieldAnswerReducer,
} from '../../project/devPlan/devPlanAction/api/updateDevPlanFieldAnswerAction';
import { loadReportsReducer } from '../../project/viewReport/api/loadReportsAction';
import { isSsoReducer } from '../../auth/sso/IsSsoAction';
import { samlAssertionReducer } from '../../auth/sso/SamlAssertionAction';
import { deleteDevPlanActionReducer } from '../../project/devPlan/devPlanAction/api/deleteDevPlanActionAction';
import {
  updateDevPlanItemDescriptionReducer,
} from '../../project/devPlan/api/updateDevPlanItemDescriptionAction';
import { updateDevPlanItemTitleReducer } from '../../project/devPlan/api/updateDevPlanItemTitleAction';
import { loadDevResourcesReducer } from '../../project/resources/loadDevResourcesAction';
import {
  updateDevPlanActionCompleteByDateReducer,
} from '../../project/devPlan/devPlanAction/api/updateActionCompleteByAction';
import { loadCurrentStatusReducer } from '../../project/loadCurrentStatusAction';
import { addDevPlanActionReducer } from '../../project/devPlan/devPlanAction/api/addDevPlanActionAction';
import { deleteDevPlanItemReducer } from '../../project/devPlan/api/deleteDevPlanItemAction';
import { addDevPlanItemReducer } from '../../project/devPlan/api/addDevPlanItemAction';
import { getDevPlanStatusesReducer } from '../../project/devPlan/devPlanAction/api/getDevPlanStatusesAction';
import {
  updateDevPlanActionStatusReducer,
} from '../../project/devPlan/devPlanAction/api/updateDevPlanActionStatusAction';
import { raterApprovalParticipantsReducer } from '../../raterApproval/api/raterApprovalParticipantsAction';
import { sendDevPlanReducer } from '../../project/devPlan/devPlanAction/api/sendDevPlanAction';
import { undeliveredEmailsReducer } from '../../project/survey/raters/undeliveredEmailsAction';
import { reportRecipientProjectsReducer } from '../../reportRecipient/api/reportRecipientProjectsAction';
import { reportRecipientParticipantsReducer } from '../../reportRecipient/api/reportRecipientParticipantsAction';
import { reportRecipientReportsReducer } from '../../reportRecipient/api/reportRecipientReportsAction';
import { deliverReportsReducer } from '../../reportRecipient/api/deliverReportsAction';
import { deliverReportsToRecipientReducer } from '../../reportRecipient/api/deliverReportsToRecipientAction';
import { getSelectedQuestionsReducer } from '../../project/createSurvey/api/getSelectedQuestionsAction';
import { addQuestionReducer } from '../../project/createSurvey/api/addQuestionAction';
import { addQuestionsForCompetencyReducer } from '../../project/createSurvey/api/addQuestionsForCompetencyAction';
import { deleteQuestionReducer } from '../../project/createSurvey/api/deleteQuestionAction';
import { deleteQuestionsForCompetencyReducer } from '../../project/createSurvey/api/deleteQuestionsForCompetencyAction';
import { getCompetenciesAndQuestionsReducer } from '../../project/createSurvey/api/getCompetenciesAndQuestionsAction';
import { applyPendingChangesReducer } from '../../project/createSurvey/api/applyPendingChangesAction';
import { raterApprovalRatersReducer } from '../../raterApproval/api/raterApprovalRatersAction';
import { sendRaterApprovalReducer } from '../../raterApproval/api/sendRaterApprovalAction';
import { raterApprovalEmailPreviewReducer } from '../../raterApproval/api/raterApprovalEmailPreviewAction';
import {
  sendReportRecipientPasswordResetEmailReducer,
} from '../../auth/forgotPassword/api/sendReportRecipientPasswordResetEmailAction';
import { unsetCreatedSurveyReducer } from '../../project/createSurvey/api/unsetCreatedSurveyAction';
import { addRaterByEmailAsApproverReducer } from '../../raterApproval/api/addRaterByEmailAsApproverAction';
import { approveRaterReducer } from '../../raterApproval/api/approveRaterAction';
import { declineRaterReducer } from '../../raterApproval/api/declineRaterAction';
import { setPortalTypeReducer } from './setPortalTypeAction';
import { clearLastSentEmailReducer } from '../../project/devPlan/devPlanAction/clearLastSentEmailAction';
import { appActivityReducer } from '../../auth/login/api/appActivityReducer';
import { setDateRangeReducer } from '../../reportRecipient/actions/setDateRangeAction';
import { setLastOnlyReducer } from '../../reportRecipient/actions/setLastOnlyAction';
import { addFilterParticipantReducer } from '../../reportRecipient/actions/addFilterParticipantAction';
import { addFilterProjectReducer } from '../../reportRecipient/actions/addFilterProjectAction';
import { removeFilterParticipantReducer } from '../../reportRecipient/actions/removeFilterParticipantAction';
import { removeFilterProjectReducer } from '../../reportRecipient/actions/removeFilterProjectAction';
import { setAllSelectedReducer } from '../../reportRecipient/actions/setAllSelectedAction';
import { setSelectedReducer } from '../../reportRecipient/actions/setSelectedAction';
import { showTimeoutModalReducer } from '../../showTimeoutModalAction';
import { showTimedOutReducer } from '../../showTimedOutAction';
import { setTimedOutHandleReducer } from '../../setTimedOutHandleAction';
import { reportDataReducer } from '../../reportRecipient/api/reportDataAction';
import { setDevPlanViewedReducer } from '../../project/devPlan/api/setDevPlanViewedAction';
import { saveEditedRaterReducer } from '../../project/survey/raters/saveEditedRaterAction';
import { addDevPlanCollaboratorReducer } from '../../project/devPlan/collaboration/api/addDevPlanCollaboratorAction';
import {
  deleteDevPlanCollaboratorReducer,
} from '../../project/devPlan/collaboration/api/deleteDevPlanCollaboratorAction';
import { addDevItemCommentReducer } from '../../project/devPlan/collaboration/api/addDevItemCommentAction';
import { updateDevItemCommentReducer } from '../../project/devPlan/collaboration/api/updateDevItemCommentAction';
import { deleteDevItemCommentReducer } from '../../project/devPlan/collaboration/api/deleteDevItemCommentAction';
import { getDevPlanCollaboratorsReducer } from '../../project/devPlan/collaboration/api/getDevPlanCollaboratorsAction';
import {
  setDevPlanCollaboratorAcceptedReducer,
} from '../../project/devPlan/collaboration/api/setDevPlanCollaboratorAcceptedAction';
import { getDevItemCommentsReducer } from '../../project/devPlan/collaboration/api/getDevItemCommentsAction';
import {
  setDevItemCommentsReadReducer,
} from '../../project/devPlan/collaboration/api/setDevItemCommentsReadAction';
import {
  authenticateCollaboratorReducer,
} from '../../project/devPlan/collaboration/api/authenticateCollaboratorAction';
import {
  sendDevPlanCollaboratorInviteReducer,
} from '../../project/devPlan/collaboration/api/sendDevPlanCollaboratorInviteAction';
import {
  sendDevItemCommentNotificationReducer,
} from '../../project/devPlan/collaboration/api/sendDevItemCommentNotificationAction';
import {
  sendParticipantCommentNotificationReducer,
} from '../../project/devPlan/collaboration/api/sendParticipantCommentNotificationAction';
import { getDevActionListItemsReducer } from '../../project/devPlan/listItems/api/getDevActionListItemsAction';
import { updateFieldAnswerListReducer } from '../../project/devPlan/listItems/api/updateFieldAnswerListAction';
import { saveFieldAnswerListReducer } from '../../project/devPlan/listItems/saveFieldAnswerListAction';
import { sendEQScoresReducer } from '../../project/viewReport/api/sendEQScoresAction';
import { logInfoReducer } from '../../traceLogging/api/logInfoAction';
import { raterInviteTimestampReducer } from './raterInviteTimestampReducer';
import { clearLoadingStateReducer } from './clearLoadingStateAction';
import { eqScoresEmailPreviewReducer } from '../../project/viewReport/api/eqScoresEmailPreviewAction';
import { getEQScoresReducer } from '../../project/viewReport/api/getEQScoresAction';
import { getProjectCSContactReducer } from '../../project/api/getProjectCSContactAction';
import { getEBookUrlReducer } from '../../project/api/getEBookUrlAction';
import { reassessmentReducer } from '../../project/api/reassessmentAction';

/**
 * The default Redux typing supports having a null app state -- but that's not a valid app state IMO, and I always write
 * my code such that the Redux store is never null.
 * To avoid doing a null-check in every reducer just to make the compiler happy about an impossible state, I just do a
 * not-null assertion in the root reducer, and type all other reducers as this guy.
 */
export type NonNullReducer = (state: AppState, action: Action) => AppState;

/**
 * The collection of all app state reducers available to the app
 */
const reducers: NonNullReducer[] = [
  // Misc
  updateStateReducer,
  setPortalTypeReducer,
  openMenuReducer,
  showTimeoutModalReducer,
  showTimedOutReducer,
  setTimedOutHandleReducer,

  // I18n
  portalLanguagesReducer,
  setLocaleReducer,
  loadTranslationsReducer,
  projectLanguagesReducer,
  loadProjMsgsReducer,
  allLanguagesReducer,

  // Feature Flags / Config
  loadFeatureFlagsReducer,
  loadConfigReducer,
  showLoginAnnouncementReducer,

  // Login/authentication
  loginReducer,
  loginTalentSmartReducer,
  loginBXReducer,
  securityQuestionKeysReducer,
  securityQuestionReducer,
  sendPortalPasswordResetEmailReducer,
  sendRaterApprovalPasswordResetEmailReducer,
  sendReportRecipientPasswordResetEmailReducer,
  newPasswordReducer,
  createSecurityChallengeReducer,
  passwordRequirementMessageReducer,
  logOutReducer,
  appActivityReducer,

  // Projects
  loadProjectsReducer,
  loadProjectSummaryReducer,
  loadCurrentStatusReducer,
  loadParticipantRequirementsReducer,
  loadProjectResourcesReducer,
  loadProjectIdReducer,
  updateConfidentialityReducer,
  loadDevResourcesReducer,
  getProjectCSContactReducer,
  getEBookUrlReducer,
  reassessmentReducer,

  // Raters
  addRaterByEmailReducer,
  addRaterByIdReducer,
  participantRatersReducer,
  previousRatersReducer,
  directoryRatersReducer,
  updateInviteDataReducer,
  inviteEmailPreviewReducer,
  approverEmailPreviewReducer,
  sendInvitationsReducer,
  sendRemindersReducer,
  raterLevelsReducer,
  deleteRaterReducer,
  saveEditedRaterReducer,
  updateRaterReducer,
  setApproverReducer,
  sendForApprovalReducer,
  undeliveredEmailsReducer,
  // TODO - remove these next two when the hanging rater-invite request issue is resolved
  raterInviteTimestampReducer,
  clearLoadingStateReducer,

  // Rater Approval
  raterApprovalParticipantsReducer,
  raterApprovalRatersReducer,
  sendRaterApprovalReducer,
  approveRaterReducer,
  declineRaterReducer,
  raterApprovalEmailPreviewReducer,
  addRaterByEmailAsApproverReducer,

  // Set Goals
  setGoalAnswerReducer,
  sendGoalsReducer,
  goalsAnswersReducer,

  //SSO
  ymcaLoginReducer,
  ymcaSsoReducer,
  isSsoReducer,
  samlAssertionReducer,

  // Create Survey
  getSelectedQuestionsReducer,
  addQuestionReducer,
  addQuestionsForCompetencyReducer,
  deleteQuestionReducer,
  deleteQuestionsForCompetencyReducer,
  getSelectedQuestionsReducer,
  getCompetenciesAndQuestionsReducer,
  applyPendingChangesReducer,
  unsetCreatedSurveyReducer,

  // Dev Plan
  getRemindersOnReducer,
  setRemindersOnReducer,
  deleteDevPlanItemReducer,
  addDevPlanItemReducer,
  getDevPlanItemsReducer,
  getDevPlanActionsReducer,
  getDevPlanFieldsAndAnswersReducer,
  updateDevPlanFieldAnswerReducer,
  deleteDevPlanActionReducer,
  updateDevPlanItemDescriptionReducer,
  updateDevPlanItemTitleReducer,
  updateDevPlanActionCompleteByDateReducer,
  addDevPlanActionReducer,
  getDevPlanStatusesReducer,
  updateDevPlanActionStatusReducer,
  sendDevPlanReducer,

  // Dev Plan Collaboration
  authenticateCollaboratorReducer,
  getDevPlanCollaboratorsReducer,
  addDevPlanCollaboratorReducer,
  setDevPlanCollaboratorAcceptedReducer,
  deleteDevPlanCollaboratorReducer,

  getDevItemCommentsReducer,
  addDevItemCommentReducer,
  updateDevItemCommentReducer,
  setDevItemCommentsReadReducer,
  deleteDevItemCommentReducer,

  sendDevPlanCollaboratorInviteReducer,
  sendDevItemCommentNotificationReducer,
  sendParticipantCommentNotificationReducer,

  clearLastSentEmailReducer,
  setDevPlanViewedReducer,

  // Dev Plan Field Answer Lists
  getDevActionListItemsReducer,
  updateFieldAnswerListReducer,
  saveFieldAnswerListReducer,

  // View Reports
  loadReportsReducer,
  reportDataReducer,
  getEQScoresReducer,
  sendEQScoresReducer,
  eqScoresEmailPreviewReducer,

  // Report Recipient
  reportRecipientProjectsReducer,
  reportRecipientParticipantsReducer,
  reportRecipientReportsReducer,
  deliverReportsReducer,
  deliverReportsToRecipientReducer,
  setDateRangeReducer,
  setLastOnlyReducer,
  addFilterParticipantReducer,
  addFilterProjectReducer,
  removeFilterParticipantReducer,
  removeFilterProjectReducer,
  setAllSelectedReducer,
  setSelectedReducer,

  logInfoReducer,
];

export const rootReducer: Reducer = (state, action) => reducers.reduce(
  (running, next) => next(running, action),
  state!,
);
